import { IMAGES } from "@/data";

export function AeroImg({ img, alt, className = "", eager = false }) {
  const src = IMAGES[img];
  return (
    <img
      src={src.local}
      alt={alt}
      loading={eager ? "eager" : "lazy"}
      className={className}
      onError={(e) => {
        if (e.target.src !== src.fallback) e.target.src = src.fallback;
      }}
    />
  );
}
